/* eslint-disable */
import {
    getToken,
    getAdminId,
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
const state = {
};

// getters
const getters = {
};

// mutations
const mutations = {
    
};

// actions
const actions = {
    EnterpriseServicesListShow({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/ad/show', data).then(res => {
            return res.data
        })
    },
    AddEnterpriseServices({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/ad/add', data).then(res => {
            return res.data
        })
    },
    DeleteEnterpriseServices({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/ad/delete', data).then(res => {
            return res.data
        })
    }
    // 用户名登录
    // NoticeAdministrationListShow({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/show', data).then(res => {
    //         return res.data
    //     })
    // },
    // AddNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/add', data).then(res => {
    //         return res.data
    //     })
    // },
    // DeleteNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/delete', data).then(res => {
    //         return res.data
    //     })
    // }
};

const EnterpriseServicesModule = {
    state,
    getters,
    actions,
    mutations
}
export default EnterpriseServicesModule
